import { useQuery } from '@tanstack/react-query';
import { projectDataClient } from '../../../../lib/connect/clients';
/**
 * PRP-04: what the proposal carried in from its pursuit. `gcTime: 0` and a
 * principal-scoped key re-authorize on every visit; a failed read never shows cached rows.
 */ export function useProposalCarriedIn(principal, projectId, includeItems) {
    return useQuery({
        queryKey: [
            'proposal-carried-in',
            principal,
            projectId,
            includeItems
        ],
        queryFn: ({ signal })=>projectDataClient.listProposalCarriedIn({
                projectId,
                includeItems
            }, {
                signal
            }),
        retry: false,
        gcTime: 0,
        refetchOnMount: 'always'
    });
}
